var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CreatePromoModal',{ref:"createPromoModal",on:{"added":_vm.addedPromo}}),_c('CreateTemplateModal',{ref:"createTemplateModal",on:{"added":_vm.addedTemplate}}),_c('TimelineModal',{ref:"timelineModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }